module.exports = __webpack_public_path__ + "img/1508415599.a66a9ecf.jpg";